// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__ojbV6","additionalInfo":"AgreementModal_additionalInfo__DzYWw"};